export const moduleNamespace = 'mercury';
export const routeNamespace = '/mercury';
